import React from 'react';

import OutlineAcademicCap from './icons/outline/academic-cap.svg';
import OutlineAdjustments from './icons/outline/adjustments.svg';
import OutlineAnnotation from './icons/outline/annotation.svg';
import OutlineArchive from './icons/outline/archive.svg';
import OutlineArrowCircleDown from './icons/outline/arrow-circle-down.svg';
import OutlineArrowCircleLeft from './icons/outline/arrow-circle-left.svg';
import OutlineArrowCircleRight from './icons/outline/arrow-circle-right.svg';
import OutlineArrowCircleUp from './icons/outline/arrow-circle-up.svg';
import OutlineArrowDown from './icons/outline/arrow-down.svg';
import OutlineArrowLeft from './icons/outline/arrow-left.svg';
import OutlineArrowNarrowDown from './icons/outline/arrow-narrow-down.svg';
import OutlineArrowNarrowLeft from './icons/outline/arrow-narrow-left.svg';
import OutlineArrowNarrowRight from './icons/outline/arrow-narrow-right.svg';
import OutlineArrowNarrowUp from './icons/outline/arrow-narrow-up.svg';
import OutlineArrowRight from './icons/outline/arrow-right.svg';
import OutlineArrowUp from './icons/outline/arrow-up.svg';
import OutlineArrowsExpand from './icons/outline/arrows-expand.svg';
import OutlineAtSymbol from './icons/outline/at-symbol.svg';
import OutlineBackspace from './icons/outline/backspace.svg';
import OutlineBadgeCheck from './icons/outline/badge-check.svg';
import OutlineBan from './icons/outline/ban.svg';
import OutlineBeaker from './icons/outline/beaker.svg';
import OutlineBell from './icons/outline/bell.svg';
import OutlineBookOpen from './icons/outline/book-open.svg';
import OutlineBookmarkAlt from './icons/outline/bookmark-alt.svg';
import OutlineBookmark from './icons/outline/bookmark.svg';
import OutlineBriefcase from './icons/outline/briefcase.svg';
import OutlineCake from './icons/outline/cake.svg';
import OutlineCalculator from './icons/outline/calculator.svg';
import OutlineCalendar from './icons/outline/calendar.svg';
import OutlineCamera from './icons/outline/camera.svg';
import OutlineCash from './icons/outline/cash.svg';
import OutlineChartBar from './icons/outline/chart-bar.svg';
import OutlineChartPie from './icons/outline/chart-pie.svg';
import OutlineChartSquareBar from './icons/outline/chart-square-bar.svg';
import OutlineChatAlt2 from './icons/outline/chat-alt-2.svg';
import OutlineChatAlt from './icons/outline/chat-alt.svg';
import OutlineChat from './icons/outline/chat.svg';
import OutlineCheckCircle from './icons/outline/check-circle.svg';
import OutlineCheck from './icons/outline/check.svg';
import OutlineChevronDoubleDown from './icons/outline/chevron-double-down.svg';
import OutlineChevronDoubleLeft from './icons/outline/chevron-double-left.svg';
import OutlineChevronDoubleRight from './icons/outline/chevron-double-right.svg';
import OutlineChevronDoubleUp from './icons/outline/chevron-double-up.svg';
import OutlineChevronDown from './icons/outline/chevron-down.svg';
import OutlineChevronLeft from './icons/outline/chevron-left.svg';
import OutlineChevronRight from './icons/outline/chevron-right.svg';
import OutlineChevronUp from './icons/outline/chevron-up.svg';
import OutlineChip from './icons/outline/chip.svg';
import OutlineClipboardCheck from './icons/outline/clipboard-check.svg';
import OutlineClipboardCopy from './icons/outline/clipboard-copy.svg';
import OutlineClipboardList from './icons/outline/clipboard-list.svg';
import OutlineClipboard from './icons/outline/clipboard.svg';
import OutlineClock from './icons/outline/clock.svg';
import OutlineCloudDownload from './icons/outline/cloud-download.svg';
import OutlineCloudUpload from './icons/outline/cloud-upload.svg';
import OutlineCloud from './icons/outline/cloud.svg';
import OutlineCode from './icons/outline/code.svg';
import OutlineCog from './icons/outline/cog.svg';
import OutlineCollection from './icons/outline/collection.svg';
import OutlineColorSwatch from './icons/outline/color-swatch.svg';
import OutlineCreditCard from './icons/outline/credit-card.svg';
import OutlineCubeTransparent from './icons/outline/cube-transparent.svg';
import OutlineCube from './icons/outline/cube.svg';
import OutlineCurrencyBangladeshi from './icons/outline/currency-bangladeshi.svg';
import OutlineCurrencyDollar from './icons/outline/currency-dollar.svg';
import OutlineCurrencyEuro from './icons/outline/currency-euro.svg';
import OutlineCurrencyPound from './icons/outline/currency-pound.svg';
import OutlineCurrencyRupee from './icons/outline/currency-rupee.svg';
import OutlineCurrencyYen from './icons/outline/currency-yen.svg';
import OutlineCursorClick from './icons/outline/cursor-click.svg';
import OutlineDatabase from './icons/outline/database.svg';
import OutlineDesktopComputer from './icons/outline/desktop-computer.svg';
import OutlineDeviceMobile from './icons/outline/device-mobile.svg';
import OutlineDeviceTablet from './icons/outline/device-tablet.svg';
import OutlineDocumentAdd from './icons/outline/document-add.svg';
import OutlineDocumentDownload from './icons/outline/document-download.svg';
import OutlineDocumentDuplicate from './icons/outline/document-duplicate.svg';
import OutlineDocumentRemove from './icons/outline/document-remove.svg';
import OutlineDocumentReport from './icons/outline/document-report.svg';
import OutlineDocumentSearch from './icons/outline/document-search.svg';
import OutlineDocumentText from './icons/outline/document-text.svg';
import OutlineDocument from './icons/outline/document.svg';
import OutlineDotsCircleHorizontal from './icons/outline/dots-circle-horizontal.svg';
import OutlineDotsHorizontal from './icons/outline/dots-horizontal.svg';
import OutlineDotsVertical from './icons/outline/dots-vertical.svg';
import OutlineDownload from './icons/outline/download.svg';
import OutlineDuplicate from './icons/outline/duplicate.svg';
import OutlineEmojiHappy from './icons/outline/emoji-happy.svg';
import OutlineEmojiSad from './icons/outline/emoji-sad.svg';
import OutlineExclamationCircle from './icons/outline/exclamation-circle.svg';
import OutlineExclamation from './icons/outline/exclamation.svg';
import OutlineExternalLink from './icons/outline/external-link.svg';
import OutlineEyeOff from './icons/outline/eye-off.svg';
import OutlineEye from './icons/outline/eye.svg';
import OutlineFastForward from './icons/outline/fast-forward.svg';
import OutlineFilm from './icons/outline/film.svg';
import OutlineFilter from './icons/outline/filter.svg';
import OutlineFingerPrint from './icons/outline/finger-print.svg';
import OutlineFire from './icons/outline/fire.svg';
import OutlineFlag from './icons/outline/flag.svg';
import OutlineFolderAdd from './icons/outline/folder-add.svg';
import OutlineFolderDownload from './icons/outline/folder-download.svg';
import OutlineFolderOpen from './icons/outline/folder-open.svg';
import OutlineFolderRemove from './icons/outline/folder-remove.svg';
import OutlineFolder from './icons/outline/folder.svg';
import OutlineGift from './icons/outline/gift.svg';
import OutlineGlobeAlt from './icons/outline/globe-alt.svg';
import OutlineGlobe from './icons/outline/globe.svg';
import OutlineHand from './icons/outline/hand.svg';
import OutlineHashtag from './icons/outline/hashtag.svg';
import OutlineHeart from './icons/outline/heart.svg';
import OutlineHome from './icons/outline/home.svg';
import OutlineIdentification from './icons/outline/identification.svg';
import OutlineInboxIn from './icons/outline/inbox-in.svg';
import OutlineInbox from './icons/outline/inbox.svg';
import OutlineInformationCircle from './icons/outline/information-circle.svg';
import OutlineKey from './icons/outline/key.svg';
import OutlineLibrary from './icons/outline/library.svg';
import OutlineLightBulb from './icons/outline/light-bulb.svg';
import OutlineLightningBolt from './icons/outline/lightning-bolt.svg';
import OutlineLink from './icons/outline/link.svg';
import OutlineLocationMarker from './icons/outline/location-marker.svg';
import OutlineLockClosed from './icons/outline/lock-closed.svg';
import OutlineLockOpen from './icons/outline/lock-open.svg';
import OutlineLogin from './icons/outline/login.svg';
import OutlineLogout from './icons/outline/logout.svg';
import OutlineMailOpen from './icons/outline/mail-open.svg';
import OutlineMail from './icons/outline/mail.svg';
import OutlineMap from './icons/outline/map.svg';
import OutlineMenuAlt1 from './icons/outline/menu-alt-1.svg';
import OutlineMenuAlt2 from './icons/outline/menu-alt-2.svg';
import OutlineMenuAlt3 from './icons/outline/menu-alt-3.svg';
import OutlineMenuAlt4 from './icons/outline/menu-alt-4.svg';
import OutlineMenu from './icons/outline/menu.svg';
import OutlineMicrophone from './icons/outline/microphone.svg';
import OutlineMinusCircle from './icons/outline/minus-circle.svg';
import OutlineMinusSm from './icons/outline/minus-sm.svg';
import OutlineMinus from './icons/outline/minus.svg';
import OutlineMoon from './icons/outline/moon.svg';
import OutlineMusicNote from './icons/outline/music-note.svg';
import OutlineNewspaper from './icons/outline/newspaper.svg';
import OutlineNoSymbol from './icons/outline/no-symbol.svg';
import OutlineOfficeBuilding from './icons/outline/office-building.svg';
import OutlinePaperAirplane from './icons/outline/paper-airplane.svg';
import OutlinePaperClip from './icons/outline/paper-clip.svg';
import OutlinePause from './icons/outline/pause.svg';
import OutlinePencilAlt from './icons/outline/pencil-alt.svg';
import OutlinePencil from './icons/outline/pencil.svg';
import OutlinePhoneIncoming from './icons/outline/phone-incoming.svg';
import OutlinePhoneMissedCall from './icons/outline/phone-missed-call.svg';
import OutlinePhoneOutgoing from './icons/outline/phone-outgoing.svg';
import OutlinePhone from './icons/outline/phone.svg';
import OutlinePhotograph from './icons/outline/photograph.svg';
import OutlinePlay from './icons/outline/play.svg';
import OutlinePlusCircle from './icons/outline/plus-circle.svg';
import OutlinePlusSm from './icons/outline/plus-sm.svg';
import OutlinePlus from './icons/outline/plus.svg';
import OutlinePresentationChartBar from './icons/outline/presentation-chart-bar.svg';
import OutlinePresentationChartLine from './icons/outline/presentation-chart-line.svg';
import OutlinePrinter from './icons/outline/printer.svg';
import OutlinePuzzle from './icons/outline/puzzle.svg';
import OutlineQrcode from './icons/outline/qrcode.svg';
import OutlineQuestionMarkCircle from './icons/outline/question-mark-circle.svg';
import OutlineReceiptRefund from './icons/outline/receipt-refund.svg';
import OutlineReceiptTax from './icons/outline/receipt-tax.svg';
import OutlineRefresh from './icons/outline/refresh.svg';
import OutlineReply from './icons/outline/reply.svg';
import OutlineRewind from './icons/outline/rewind.svg';
import OutlineRss from './icons/outline/rss.svg';
import OutlineSaveAs from './icons/outline/save-as.svg';
import OutlineSave from './icons/outline/save.svg';
import OutlineScale from './icons/outline/scale.svg';
import OutlineScissors from './icons/outline/scissors.svg';
import OutlineSearchCircle from './icons/outline/search-circle.svg';
import OutlineSearch from './icons/outline/search.svg';
import OutlineSelector from './icons/outline/selector.svg';
import OutlineServer from './icons/outline/server.svg';
import OutlineShare from './icons/outline/share.svg';
import OutlineShieldCheck from './icons/outline/shield-check.svg';
import OutlineShieldExclamation from './icons/outline/shield-exclamation.svg';
import OutlineShoppingBag from './icons/outline/shopping-bag.svg';
import OutlineShoppingCart from './icons/outline/shopping-cart.svg';
import OutlineSortAscending from './icons/outline/sort-ascending.svg';
import OutlineSortDescending from './icons/outline/sort-descending.svg';
import OutlineSparkles from './icons/outline/sparkles.svg';
import OutlineSpeakerphone from './icons/outline/speakerphone.svg';
import OutlineStar from './icons/outline/star.svg';
import OutlineStatusOffline from './icons/outline/status-offline.svg';
import OutlineStatusOnline from './icons/outline/status-online.svg';
import OutlineStop from './icons/outline/stop.svg';
import OutlineSun from './icons/outline/sun.svg';
import OutlineSupport from './icons/outline/support.svg';
import OutlineSwitchHorizontal from './icons/outline/switch-horizontal.svg';
import OutlineSwitchVertical from './icons/outline/switch-vertical.svg';
import OutlineTable from './icons/outline/table.svg';
import OutlineTag from './icons/outline/tag.svg';
import OutlineTemplate from './icons/outline/template.svg';
import OutlineTerminal from './icons/outline/terminal.svg';
import OutlineThumbDown from './icons/outline/thumb-down.svg';
import OutlineThumbUp from './icons/outline/thumb-up.svg';
import OutlineTicket from './icons/outline/ticket.svg';
import OutlineTranslate from './icons/outline/translate.svg';
import OutlineTrash from './icons/outline/trash.svg';
import OutlineTrendingDown from './icons/outline/trending-down.svg';
import OutlineTrendingUp from './icons/outline/trending-up.svg';
import OutlineTruck from './icons/outline/truck.svg';
import OutlineUpload from './icons/outline/upload.svg';
import OutlineUserAdd from './icons/outline/user-add.svg';
import OutlineUserCircle from './icons/outline/user-circle.svg';
import OutlineUserGroup from './icons/outline/user-group.svg';
import OutlineUserRemove from './icons/outline/user-remove.svg';
import OutlineUser from './icons/outline/user.svg';
import OutlineUsers from './icons/outline/users.svg';
import OutlineVariable from './icons/outline/variable.svg';
import OutlineVideoCamera from './icons/outline/video-camera.svg';
import OutlineViewBoards from './icons/outline/view-boards.svg';
import OutlineViewGridAdd from './icons/outline/view-grid-add.svg';
import OutlineViewGrid from './icons/outline/view-grid.svg';
import OutlineViewList from './icons/outline/view-list.svg';
import OutlineVolumeOff from './icons/outline/volume-off.svg';
import OutlineVolumeUp from './icons/outline/volume-up.svg';
import OutlineWifi from './icons/outline/wifi.svg';
import OutlineXCircle from './icons/outline/x-circle.svg';
import OutlineX from './icons/outline/x.svg';
import OutlineZoomIn from './icons/outline/zoom-in.svg';
import OutlineZoomOut from './icons/outline/zoom-out.svg';
import SolidAcademicCap from './icons/solid/academic-cap.svg';
import SolidAdjustments from './icons/solid/adjustments.svg';
import SolidAnnotation from './icons/solid/annotation.svg';
import SolidArchive from './icons/solid/archive.svg';
import SolidArrowCircleDown from './icons/solid/arrow-circle-down.svg';
import SolidArrowCircleLeft from './icons/solid/arrow-circle-left.svg';
import SolidArrowCircleRight from './icons/solid/arrow-circle-right.svg';
import SolidArrowCircleUp from './icons/solid/arrow-circle-up.svg';
import SolidArrowDown from './icons/solid/arrow-down.svg';
import SolidArrowLeft from './icons/solid/arrow-left.svg';
import SolidArrowNarrowDown from './icons/solid/arrow-narrow-down.svg';
import SolidArrowNarrowLeft from './icons/solid/arrow-narrow-left.svg';
import SolidArrowNarrowRight from './icons/solid/arrow-narrow-right.svg';
import SolidArrowNarrowUp from './icons/solid/arrow-narrow-up.svg';
import SolidArrowRight from './icons/solid/arrow-right.svg';
import SolidArrowUp from './icons/solid/arrow-up.svg';
import SolidArrowsExpand from './icons/solid/arrows-expand.svg';
import SolidAtSymbol from './icons/solid/at-symbol.svg';
import SolidBackspace from './icons/solid/backspace.svg';
import SolidBadgeCheck from './icons/solid/badge-check.svg';
import SolidBan from './icons/solid/ban.svg';
import SolidBeaker from './icons/solid/beaker.svg';
import SolidBell from './icons/solid/bell.svg';
import SolidBookOpen from './icons/solid/book-open.svg';
import SolidBookmarkAlt from './icons/solid/bookmark-alt.svg';
import SolidBookmark from './icons/solid/bookmark.svg';
import SolidBriefcase from './icons/solid/briefcase.svg';
import SolidCake from './icons/solid/cake.svg';
import SolidCalculator from './icons/solid/calculator.svg';
import SolidCalendar from './icons/solid/calendar.svg';
import SolidCamera from './icons/solid/camera.svg';
import SolidCash from './icons/solid/cash.svg';
import SolidChartBar from './icons/solid/chart-bar.svg';
import SolidChartPie from './icons/solid/chart-pie.svg';
import SolidChartSquareBar from './icons/solid/chart-square-bar.svg';
import SolidChatAlt2 from './icons/solid/chat-alt-2.svg';
import SolidChatAlt from './icons/solid/chat-alt.svg';
import SolidChat from './icons/solid/chat.svg';
import SolidCheckCircle from './icons/solid/check-circle.svg';
import SolidCheck from './icons/solid/check.svg';
import SolidChevronDoubleDown from './icons/solid/chevron-double-down.svg';
import SolidChevronDoubleLeft from './icons/solid/chevron-double-left.svg';
import SolidChevronDoubleRight from './icons/solid/chevron-double-right.svg';
import SolidChevronDoubleUp from './icons/solid/chevron-double-up.svg';
import SolidChevronDown from './icons/solid/chevron-down.svg';
import SolidChevronLeft from './icons/solid/chevron-left.svg';
import SolidChevronRight from './icons/solid/chevron-right.svg';
import SolidChevronUp from './icons/solid/chevron-up.svg';
import SolidChip from './icons/solid/chip.svg';
import SolidClipboardCheck from './icons/solid/clipboard-check.svg';
import SolidClipboardCopy from './icons/solid/clipboard-copy.svg';
import SolidClipboardList from './icons/solid/clipboard-list.svg';
import SolidClipboard from './icons/solid/clipboard.svg';
import SolidClock from './icons/solid/clock.svg';
import SolidCloudDownload from './icons/solid/cloud-download.svg';
import SolidCloudUpload from './icons/solid/cloud-upload.svg';
import SolidCloud from './icons/solid/cloud.svg';
import SolidCode from './icons/solid/code.svg';
import SolidCog from './icons/solid/cog.svg';
import SolidCollection from './icons/solid/collection.svg';
import SolidColorSwatch from './icons/solid/color-swatch.svg';
import SolidCreditCard from './icons/solid/credit-card.svg';
import SolidCubeTransparent from './icons/solid/cube-transparent.svg';
import SolidCube from './icons/solid/cube.svg';
import SolidCurrencyBangladeshi from './icons/solid/currency-bangladeshi.svg';
import SolidCurrencyDollar from './icons/solid/currency-dollar.svg';
import SolidCurrencyEuro from './icons/solid/currency-euro.svg';
import SolidCurrencyPound from './icons/solid/currency-pound.svg';
import SolidCurrencyRupee from './icons/solid/currency-rupee.svg';
import SolidCurrencyYen from './icons/solid/currency-yen.svg';
import SolidCursorClick from './icons/solid/cursor-click.svg';
import SolidDatabase from './icons/solid/database.svg';
import SolidDesktopComputer from './icons/solid/desktop-computer.svg';
import SolidDeviceMobile from './icons/solid/device-mobile.svg';
import SolidDeviceTablet from './icons/solid/device-tablet.svg';
import SolidDocumentAdd from './icons/solid/document-add.svg';
import SolidDocumentDownload from './icons/solid/document-download.svg';
import SolidDocumentDuplicate from './icons/solid/document-duplicate.svg';
import SolidDocumentRemove from './icons/solid/document-remove.svg';
import SolidDocumentReport from './icons/solid/document-report.svg';
import SolidDocumentSearch from './icons/solid/document-search.svg';
import SolidDocumentText from './icons/solid/document-text.svg';
import SolidDocument from './icons/solid/document.svg';
import SolidDotsCircleHorizontal from './icons/solid/dots-circle-horizontal.svg';
import SolidDotsHorizontal from './icons/solid/dots-horizontal.svg';
import SolidDotsVertical from './icons/solid/dots-vertical.svg';
import SolidDownload from './icons/solid/download.svg';
import SolidDuplicate from './icons/solid/duplicate.svg';
import SolidEmojiHappy from './icons/solid/emoji-happy.svg';
import SolidEmojiSad from './icons/solid/emoji-sad.svg';
import SolidExclamationCircle from './icons/solid/exclamation-circle.svg';
import SolidExclamation from './icons/solid/exclamation.svg';
import SolidExternalLink from './icons/solid/external-link.svg';
import SolidEyeOff from './icons/solid/eye-off.svg';
import SolidEye from './icons/solid/eye.svg';
import SolidFastForward from './icons/solid/fast-forward.svg';
import SolidFilm from './icons/solid/film.svg';
import SolidFilter from './icons/solid/filter.svg';
import SolidFingerPrint from './icons/solid/finger-print.svg';
import SolidFire from './icons/solid/fire.svg';
import SolidFlag from './icons/solid/flag.svg';
import SolidFolderAdd from './icons/solid/folder-add.svg';
import SolidFolderDownload from './icons/solid/folder-download.svg';
import SolidFolderOpen from './icons/solid/folder-open.svg';
import SolidFolderRemove from './icons/solid/folder-remove.svg';
import SolidFolder from './icons/solid/folder.svg';
import SolidGift from './icons/solid/gift.svg';
import SolidGlobeAlt from './icons/solid/globe-alt.svg';
import SolidGlobe from './icons/solid/globe.svg';
import SolidHand from './icons/solid/hand.svg';
import SolidHashtag from './icons/solid/hashtag.svg';
import SolidHeart from './icons/solid/heart.svg';
import SolidHome from './icons/solid/home.svg';
import SolidIdentification from './icons/solid/identification.svg';
import SolidInboxIn from './icons/solid/inbox-in.svg';
import SolidInbox from './icons/solid/inbox.svg';
import SolidInformationCircle from './icons/solid/information-circle.svg';
import SolidKey from './icons/solid/key.svg';
import SolidLibrary from './icons/solid/library.svg';
import SolidLightBulb from './icons/solid/light-bulb.svg';
import SolidLightningBolt from './icons/solid/lightning-bolt.svg';
import SolidLink from './icons/solid/link.svg';
import SolidLocationMarker from './icons/solid/location-marker.svg';
import SolidLockClosed from './icons/solid/lock-closed.svg';
import SolidLockOpen from './icons/solid/lock-open.svg';
import SolidLogin from './icons/solid/login.svg';
import SolidLogout from './icons/solid/logout.svg';
import SolidMailOpen from './icons/solid/mail-open.svg';
import SolidMail from './icons/solid/mail.svg';
import SolidMap from './icons/solid/map.svg';
import SolidMenuAlt1 from './icons/solid/menu-alt-1.svg';
import SolidMenuAlt2 from './icons/solid/menu-alt-2.svg';
import SolidMenuAlt3 from './icons/solid/menu-alt-3.svg';
import SolidMenuAlt4 from './icons/solid/menu-alt-4.svg';
import SolidMenu from './icons/solid/menu.svg';
import SolidMicrophone from './icons/solid/microphone.svg';
import SolidMinusCircle from './icons/solid/minus-circle.svg';
import SolidMinusSm from './icons/solid/minus-sm.svg';
import SolidMinus from './icons/solid/minus.svg';
import SolidMoon from './icons/solid/moon.svg';
import SolidMusicNote from './icons/solid/music-note.svg';
import SolidNewspaper from './icons/solid/newspaper.svg';
import SolidNoSymbol from './icons/solid/no-symbol.svg';
import SolidOfficeBuilding from './icons/solid/office-building.svg';
import SolidPaperAirplane from './icons/solid/paper-airplane.svg';
import SolidPaperClip from './icons/solid/paper-clip.svg';
import SolidPause from './icons/solid/pause.svg';
import SolidPencilAlt from './icons/solid/pencil-alt.svg';
import SolidPencil from './icons/solid/pencil.svg';
import SolidPhoneIncoming from './icons/solid/phone-incoming.svg';
import SolidPhoneMissedCall from './icons/solid/phone-missed-call.svg';
import SolidPhoneOutgoing from './icons/solid/phone-outgoing.svg';
import SolidPhone from './icons/solid/phone.svg';
import SolidPhotograph from './icons/solid/photograph.svg';
import SolidPlay from './icons/solid/play.svg';
import SolidPlusCircle from './icons/solid/plus-circle.svg';
import SolidPlusSm from './icons/solid/plus-sm.svg';
import SolidPlus from './icons/solid/plus.svg';
import SolidPresentationChartBar from './icons/solid/presentation-chart-bar.svg';
import SolidPresentationChartLine from './icons/solid/presentation-chart-line.svg';
import SolidPrinter from './icons/solid/printer.svg';
import SolidPuzzle from './icons/solid/puzzle.svg';
import SolidQrcode from './icons/solid/qrcode.svg';
import SolidQuestionMarkCircle from './icons/solid/question-mark-circle.svg';
import SolidReceiptRefund from './icons/solid/receipt-refund.svg';
import SolidReceiptTax from './icons/solid/receipt-tax.svg';
import SolidRefresh from './icons/solid/refresh.svg';
import SolidReply from './icons/solid/reply.svg';
import SolidRewind from './icons/solid/rewind.svg';
import SolidRss from './icons/solid/rss.svg';
import SolidSaveAs from './icons/solid/save-as.svg';
import SolidSave from './icons/solid/save.svg';
import SolidScale from './icons/solid/scale.svg';
import SolidScissors from './icons/solid/scissors.svg';
import SolidSearchCircle from './icons/solid/search-circle.svg';
import SolidSearch from './icons/solid/search.svg';
import SolidSelector from './icons/solid/selector.svg';
import SolidServer from './icons/solid/server.svg';
import SolidShare from './icons/solid/share.svg';
import SolidShieldCheck from './icons/solid/shield-check.svg';
import SolidShieldExclamation from './icons/solid/shield-exclamation.svg';
import SolidShoppingBag from './icons/solid/shopping-bag.svg';
import SolidShoppingCart from './icons/solid/shopping-cart.svg';
import SolidSortAscending from './icons/solid/sort-ascending.svg';
import SolidSortDescending from './icons/solid/sort-descending.svg';
import SolidSparkles from './icons/solid/sparkles.svg';
import SolidSpeakerphone from './icons/solid/speakerphone.svg';
import SolidStar from './icons/solid/star.svg';
import SolidStatusOffline from './icons/solid/status-offline.svg';
import SolidStatusOnline from './icons/solid/status-online.svg';
import SolidStop from './icons/solid/stop.svg';
import SolidSun from './icons/solid/sun.svg';
import SolidSupport from './icons/solid/support.svg';
import SolidSwitchHorizontal from './icons/solid/switch-horizontal.svg';
import SolidSwitchVertical from './icons/solid/switch-vertical.svg';
import SolidTable from './icons/solid/table.svg';
import SolidTag from './icons/solid/tag.svg';
import SolidTemplate from './icons/solid/template.svg';
import SolidTerminal from './icons/solid/terminal.svg';
import SolidThumbDown from './icons/solid/thumb-down.svg';
import SolidThumbUp from './icons/solid/thumb-up.svg';
import SolidTicket from './icons/solid/ticket.svg';
import SolidTranslate from './icons/solid/translate.svg';
import SolidTrash from './icons/solid/trash.svg';
import SolidTrendingDown from './icons/solid/trending-down.svg';
import SolidTrendingUp from './icons/solid/trending-up.svg';
import SolidTruck from './icons/solid/truck.svg';
import SolidUpload from './icons/solid/upload.svg';
import SolidUserAdd from './icons/solid/user-add.svg';
import SolidUserCircle from './icons/solid/user-circle.svg';
import SolidUserGroup from './icons/solid/user-group.svg';
import SolidUserRemove from './icons/solid/user-remove.svg';
import SolidUser from './icons/solid/user.svg';
import SolidUsers from './icons/solid/users.svg';
import SolidVariable from './icons/solid/variable.svg';
import SolidVideoCamera from './icons/solid/video-camera.svg';
import SolidViewBoards from './icons/solid/view-boards.svg';
import SolidViewGridAdd from './icons/solid/view-grid-add.svg';
import SolidViewGrid from './icons/solid/view-grid.svg';
import SolidViewList from './icons/solid/view-list.svg';
import SolidVolumeOff from './icons/solid/volume-off.svg';
import SolidVolumeUp from './icons/solid/volume-up.svg';
import SolidWifi from './icons/solid/wifi.svg';
import SolidXCircle from './icons/solid/x-circle.svg';
import SolidX from './icons/solid/x.svg';
import SolidZoomIn from './icons/solid/zoom-in.svg';
import SolidZoomOut from './icons/solid/zoom-out.svg';

const getIcon = (iconName: string, solid: boolean = false) => {
  if (solid) {
    switch (iconName) {
      case 'academic-cap':
        return SolidAcademicCap;
      case 'adjustments':
        return SolidAdjustments;
      case 'annotation':
        return SolidAnnotation;
      case 'archive':
        return SolidArchive;
      case 'arrow-circle-down':
        return SolidArrowCircleDown;
      case 'arrow-circle-left':
        return SolidArrowCircleLeft;
      case 'arrow-circle-right':
        return SolidArrowCircleRight;
      case 'arrow-circle-up':
        return SolidArrowCircleUp;
      case 'arrow-down':
        return SolidArrowDown;
      case 'arrow-left':
        return SolidArrowLeft;
      case 'arrow-narrow-down':
        return SolidArrowNarrowDown;
      case 'arrow-narrow-left':
        return SolidArrowNarrowLeft;
      case 'arrow-narrow-right':
        return SolidArrowNarrowRight;
      case 'arrow-narrow-up':
        return SolidArrowNarrowUp;
      case 'arrow-right':
        return SolidArrowRight;
      case 'arrow-up':
        return SolidArrowUp;
      case 'arrows-expand':
        return SolidArrowsExpand;
      case 'at-symbol':
        return SolidAtSymbol;
      case 'backspace':
        return SolidBackspace;
      case 'badge-check':
        return SolidBadgeCheck;
      case 'ban':
        return SolidBan;
      case 'beaker':
        return SolidBeaker;
      case 'bell':
        return SolidBell;
      case 'book-open':
        return SolidBookOpen;
      case 'bookmark-alt':
        return SolidBookmarkAlt;
      case 'bookmark':
        return SolidBookmark;
      case 'briefcase':
        return SolidBriefcase;
      case 'cake':
        return SolidCake;
      case 'calculator':
        return SolidCalculator;
      case 'calendar':
        return SolidCalendar;
      case 'camera':
        return SolidCamera;
      case 'cash':
        return SolidCash;
      case 'chart-bar':
        return SolidChartBar;
      case 'chart-pie':
        return SolidChartPie;
      case 'chart-square-bar':
        return SolidChartSquareBar;
      case 'chat-alt-2':
        return SolidChatAlt2;
      case 'chat-alt':
        return SolidChatAlt;
      case 'chat':
        return SolidChat;
      case 'check-circle':
        return SolidCheckCircle;
      case 'check':
        return SolidCheck;
      case 'chevron-double-down':
        return SolidChevronDoubleDown;
      case 'chevron-double-left':
        return SolidChevronDoubleLeft;
      case 'chevron-double-right':
        return SolidChevronDoubleRight;
      case 'chevron-double-up':
        return SolidChevronDoubleUp;
      case 'chevron-down':
        return SolidChevronDown;
      case 'chevron-left':
        return SolidChevronLeft;
      case 'chevron-right':
        return SolidChevronRight;
      case 'chevron-up':
        return SolidChevronUp;
      case 'chip':
        return SolidChip;
      case 'clipboard-check':
        return SolidClipboardCheck;
      case 'clipboard-copy':
        return SolidClipboardCopy;
      case 'clipboard-list':
        return SolidClipboardList;
      case 'clipboard':
        return SolidClipboard;
      case 'clock':
        return SolidClock;
      case 'cloud-download':
        return SolidCloudDownload;
      case 'cloud-upload':
        return SolidCloudUpload;
      case 'cloud':
        return SolidCloud;
      case 'code':
        return SolidCode;
      case 'cog':
        return SolidCog;
      case 'collection':
        return SolidCollection;
      case 'color-swatch':
        return SolidColorSwatch;
      case 'credit-card':
        return SolidCreditCard;
      case 'cube-transparent':
        return SolidCubeTransparent;
      case 'cube':
        return SolidCube;
      case 'currency-bangladeshi':
        return SolidCurrencyBangladeshi;
      case 'currency-dollar':
        return SolidCurrencyDollar;
      case 'currency-euro':
        return SolidCurrencyEuro;
      case 'currency-pound':
        return SolidCurrencyPound;
      case 'currency-rupee':
        return SolidCurrencyRupee;
      case 'currency-yen':
        return SolidCurrencyYen;
      case 'cursor-click':
        return SolidCursorClick;
      case 'database':
        return SolidDatabase;
      case 'desktop-computer':
        return SolidDesktopComputer;
      case 'device-mobile':
        return SolidDeviceMobile;
      case 'device-tablet':
        return SolidDeviceTablet;
      case 'document-add':
        return SolidDocumentAdd;
      case 'document-download':
        return SolidDocumentDownload;
      case 'document-duplicate':
        return SolidDocumentDuplicate;
      case 'document-remove':
        return SolidDocumentRemove;
      case 'document-report':
        return SolidDocumentReport;
      case 'document-search':
        return SolidDocumentSearch;
      case 'document-text':
        return SolidDocumentText;
      case 'document':
        return SolidDocument;
      case 'dots-circle-horizontal':
        return SolidDotsCircleHorizontal;
      case 'dots-horizontal':
        return SolidDotsHorizontal;
      case 'dots-vertical':
        return SolidDotsVertical;
      case 'download':
        return SolidDownload;
      case 'duplicate':
        return SolidDuplicate;
      case 'emoji-happy':
        return SolidEmojiHappy;
      case 'emoji-sad':
        return SolidEmojiSad;
      case 'exclamation-circle':
        return SolidExclamationCircle;
      case 'exclamation':
        return SolidExclamation;
      case 'external-link':
        return SolidExternalLink;
      case 'eye-off':
        return SolidEyeOff;
      case 'eye':
        return SolidEye;
      case 'fast-forward':
        return SolidFastForward;
      case 'film':
        return SolidFilm;
      case 'filter':
        return SolidFilter;
      case 'finger-print':
        return SolidFingerPrint;
      case 'fire':
        return SolidFire;
      case 'flag':
        return SolidFlag;
      case 'folder-add':
        return SolidFolderAdd;
      case 'folder-download':
        return SolidFolderDownload;
      case 'folder-open':
        return SolidFolderOpen;
      case 'folder-remove':
        return SolidFolderRemove;
      case 'folder':
        return SolidFolder;
      case 'gift':
        return SolidGift;
      case 'globe-alt':
        return SolidGlobeAlt;
      case 'globe':
        return SolidGlobe;
      case 'hand':
        return SolidHand;
      case 'hashtag':
        return SolidHashtag;
      case 'heart':
        return SolidHeart;
      case 'home':
        return SolidHome;
      case 'identification':
        return SolidIdentification;
      case 'inbox-in':
        return SolidInboxIn;
      case 'inbox':
        return SolidInbox;
      case 'information-circle':
        return SolidInformationCircle;
      case 'key':
        return SolidKey;
      case 'library':
        return SolidLibrary;
      case 'light-bulb':
        return SolidLightBulb;
      case 'lightning-bolt':
        return SolidLightningBolt;
      case 'link':
        return SolidLink;
      case 'location-marker':
        return SolidLocationMarker;
      case 'lock-closed':
        return SolidLockClosed;
      case 'lock-open':
        return SolidLockOpen;
      case 'login':
        return SolidLogin;
      case 'logout':
        return SolidLogout;
      case 'mail-open':
        return SolidMailOpen;
      case 'mail':
        return SolidMail;
      case 'map':
        return SolidMap;
      case 'menu-alt-1':
        return SolidMenuAlt1;
      case 'menu-alt-2':
        return SolidMenuAlt2;
      case 'menu-alt-3':
        return SolidMenuAlt3;
      case 'menu-alt-4':
        return SolidMenuAlt4;
      case 'menu':
        return SolidMenu;
      case 'microphone':
        return SolidMicrophone;
      case 'minus-circle':
        return SolidMinusCircle;
      case 'minus-sm':
        return SolidMinusSm;
      case 'minus':
        return SolidMinus;
      case 'moon':
        return SolidMoon;
      case 'music-note':
        return SolidMusicNote;
      case 'newspaper':
        return SolidNewspaper;
      case 'no-symbol':
        return SolidNoSymbol;
      case 'office-building':
        return SolidOfficeBuilding;
      case 'paper-airplane':
        return SolidPaperAirplane;
      case 'paper-clip':
        return SolidPaperClip;
      case 'pause':
        return SolidPause;
      case 'pencil-alt':
        return SolidPencilAlt;
      case 'pencil':
        return SolidPencil;
      case 'phone-incoming':
        return SolidPhoneIncoming;
      case 'phone-missed-call':
        return SolidPhoneMissedCall;
      case 'phone-outgoing':
        return SolidPhoneOutgoing;
      case 'phone':
        return SolidPhone;
      case 'photograph':
        return SolidPhotograph;
      case 'play':
        return SolidPlay;
      case 'plus-circle':
        return SolidPlusCircle;
      case 'plus-sm':
        return SolidPlusSm;
      case 'plus':
        return SolidPlus;
      case 'presentation-chart-bar':
        return SolidPresentationChartBar;
      case 'presentation-chart-line':
        return SolidPresentationChartLine;
      case 'printer':
        return SolidPrinter;
      case 'puzzle':
        return SolidPuzzle;
      case 'qrcode':
        return SolidQrcode;
      case 'question-mark-circle':
        return SolidQuestionMarkCircle;
      case 'receipt-refund':
        return SolidReceiptRefund;
      case 'receipt-tax':
        return SolidReceiptTax;
      case 'refresh':
        return SolidRefresh;
      case 'reply':
        return SolidReply;
      case 'rewind':
        return SolidRewind;
      case 'rss':
        return SolidRss;
      case 'save-as':
        return SolidSaveAs;
      case 'save':
        return SolidSave;
      case 'scale':
        return SolidScale;
      case 'scissors':
        return SolidScissors;
      case 'search-circle':
        return SolidSearchCircle;
      case 'search':
        return SolidSearch;
      case 'selector':
        return SolidSelector;
      case 'server':
        return SolidServer;
      case 'share':
        return SolidShare;
      case 'shield-check':
        return SolidShieldCheck;
      case 'shield-exclamation':
        return SolidShieldExclamation;
      case 'shopping-bag':
        return SolidShoppingBag;
      case 'shopping-cart':
        return SolidShoppingCart;
      case 'sort-ascending':
        return SolidSortAscending;
      case 'sort-descending':
        return SolidSortDescending;
      case 'sparkles':
        return SolidSparkles;
      case 'speakerphone':
        return SolidSpeakerphone;
      case 'star':
        return SolidStar;
      case 'status-offline':
        return SolidStatusOffline;
      case 'status-online':
        return SolidStatusOnline;
      case 'stop':
        return SolidStop;
      case 'sun':
        return SolidSun;
      case 'support':
        return SolidSupport;
      case 'switch-horizontal':
        return SolidSwitchHorizontal;
      case 'switch-vertical':
        return SolidSwitchVertical;
      case 'table':
        return SolidTable;
      case 'tag':
        return SolidTag;
      case 'template':
        return SolidTemplate;
      case 'terminal':
        return SolidTerminal;
      case 'thumb-down':
        return SolidThumbDown;
      case 'thumb-up':
        return SolidThumbUp;
      case 'ticket':
        return SolidTicket;
      case 'translate':
        return SolidTranslate;
      case 'trash':
        return SolidTrash;
      case 'trending-down':
        return SolidTrendingDown;
      case 'trending-up':
        return SolidTrendingUp;
      case 'truck':
        return SolidTruck;
      case 'upload':
        return SolidUpload;
      case 'user-add':
        return SolidUserAdd;
      case 'user-circle':
        return SolidUserCircle;
      case 'user-group':
        return SolidUserGroup;
      case 'user-remove':
        return SolidUserRemove;
      case 'user':
        return SolidUser;
      case 'users':
        return SolidUsers;
      case 'variable':
        return SolidVariable;
      case 'video-camera':
        return SolidVideoCamera;
      case 'view-boards':
        return SolidViewBoards;
      case 'view-grid-add':
        return SolidViewGridAdd;
      case 'view-grid':
        return SolidViewGrid;
      case 'view-list':
        return SolidViewList;
      case 'volume-off':
        return SolidVolumeOff;
      case 'volume-up':
        return SolidVolumeUp;
      case 'wifi':
        return SolidWifi;
      case 'x-circle':
        return SolidXCircle;
      case 'x':
        return SolidX;
      case 'zoom-in':
        return SolidZoomIn;
      case 'zoom-out':
        return SolidZoomOut;
      default:
        return SolidDocument;
    }
  } else {
    switch (iconName) {
      case 'academic-cap':
        return OutlineAcademicCap;
      case 'adjustments':
        return OutlineAdjustments;
      case 'annotation':
        return OutlineAnnotation;
      case 'archive':
        return OutlineArchive;
      case 'arrow-circle-down':
        return OutlineArrowCircleDown;
      case 'arrow-circle-left':
        return OutlineArrowCircleLeft;
      case 'arrow-circle-right':
        return OutlineArrowCircleRight;
      case 'arrow-circle-up':
        return OutlineArrowCircleUp;
      case 'arrow-down':
        return OutlineArrowDown;
      case 'arrow-left':
        return OutlineArrowLeft;
      case 'arrow-narrow-down':
        return OutlineArrowNarrowDown;
      case 'arrow-narrow-left':
        return OutlineArrowNarrowLeft;
      case 'arrow-narrow-right':
        return OutlineArrowNarrowRight;
      case 'arrow-narrow-up':
        return OutlineArrowNarrowUp;
      case 'arrow-right':
        return OutlineArrowRight;
      case 'arrow-up':
        return OutlineArrowUp;
      case 'arrows-expand':
        return OutlineArrowsExpand;
      case 'at-symbol':
        return OutlineAtSymbol;
      case 'backspace':
        return OutlineBackspace;
      case 'badge-check':
        return OutlineBadgeCheck;
      case 'ban':
        return OutlineBan;
      case 'beaker':
        return OutlineBeaker;
      case 'bell':
        return OutlineBell;
      case 'book-open':
        return OutlineBookOpen;
      case 'bookmark-alt':
        return OutlineBookmarkAlt;
      case 'bookmark':
        return OutlineBookmark;
      case 'briefcase':
        return OutlineBriefcase;
      case 'cake':
        return OutlineCake;
      case 'calculator':
        return OutlineCalculator;
      case 'calendar':
        return OutlineCalendar;
      case 'camera':
        return OutlineCamera;
      case 'cash':
        return OutlineCash;
      case 'chart-bar':
        return OutlineChartBar;
      case 'chart-pie':
        return OutlineChartPie;
      case 'chart-square-bar':
        return OutlineChartSquareBar;
      case 'chat-alt-2':
        return OutlineChatAlt2;
      case 'chat-alt':
        return OutlineChatAlt;
      case 'chat':
        return OutlineChat;
      case 'check-circle':
        return OutlineCheckCircle;
      case 'check':
        return OutlineCheck;
      case 'chevron-double-down':
        return OutlineChevronDoubleDown;
      case 'chevron-double-left':
        return OutlineChevronDoubleLeft;
      case 'chevron-double-right':
        return OutlineChevronDoubleRight;
      case 'chevron-double-up':
        return OutlineChevronDoubleUp;
      case 'chevron-down':
        return OutlineChevronDown;
      case 'chevron-left':
        return OutlineChevronLeft;
      case 'chevron-right':
        return OutlineChevronRight;
      case 'chevron-up':
        return OutlineChevronUp;
      case 'chip':
        return OutlineChip;
      case 'clipboard-check':
        return OutlineClipboardCheck;
      case 'clipboard-copy':
        return OutlineClipboardCopy;
      case 'clipboard-list':
        return OutlineClipboardList;
      case 'clipboard':
        return OutlineClipboard;
      case 'clock':
        return OutlineClock;
      case 'cloud-download':
        return OutlineCloudDownload;
      case 'cloud-upload':
        return OutlineCloudUpload;
      case 'cloud':
        return OutlineCloud;
      case 'code':
        return OutlineCode;
      case 'cog':
        return OutlineCog;
      case 'collection':
        return OutlineCollection;
      case 'color-swatch':
        return OutlineColorSwatch;
      case 'credit-card':
        return OutlineCreditCard;
      case 'cube-transparent':
        return OutlineCubeTransparent;
      case 'cube':
        return OutlineCube;
      case 'currency-bangladeshi':
        return OutlineCurrencyBangladeshi;
      case 'currency-dollar':
        return OutlineCurrencyDollar;
      case 'currency-euro':
        return OutlineCurrencyEuro;
      case 'currency-pound':
        return OutlineCurrencyPound;
      case 'currency-rupee':
        return OutlineCurrencyRupee;
      case 'currency-yen':
        return OutlineCurrencyYen;
      case 'cursor-click':
        return OutlineCursorClick;
      case 'database':
        return OutlineDatabase;
      case 'desktop-computer':
        return OutlineDesktopComputer;
      case 'device-mobile':
        return OutlineDeviceMobile;
      case 'device-tablet':
        return OutlineDeviceTablet;
      case 'document-add':
        return OutlineDocumentAdd;
      case 'document-download':
        return OutlineDocumentDownload;
      case 'document-duplicate':
        return OutlineDocumentDuplicate;
      case 'document-remove':
        return OutlineDocumentRemove;
      case 'document-report':
        return OutlineDocumentReport;
      case 'document-search':
        return OutlineDocumentSearch;
      case 'document-text':
        return OutlineDocumentText;
      case 'document':
        return OutlineDocument;
      case 'dots-circle-horizontal':
        return OutlineDotsCircleHorizontal;
      case 'dots-horizontal':
        return OutlineDotsHorizontal;
      case 'dots-vertical':
        return OutlineDotsVertical;
      case 'download':
        return OutlineDownload;
      case 'duplicate':
        return OutlineDuplicate;
      case 'emoji-happy':
        return OutlineEmojiHappy;
      case 'emoji-sad':
        return OutlineEmojiSad;
      case 'exclamation-circle':
        return OutlineExclamationCircle;
      case 'exclamation':
        return OutlineExclamation;
      case 'external-link':
        return OutlineExternalLink;
      case 'eye-off':
        return OutlineEyeOff;
      case 'eye':
        return OutlineEye;
      case 'fast-forward':
        return OutlineFastForward;
      case 'film':
        return OutlineFilm;
      case 'filter':
        return OutlineFilter;
      case 'finger-print':
        return OutlineFingerPrint;
      case 'fire':
        return OutlineFire;
      case 'flag':
        return OutlineFlag;
      case 'folder-add':
        return OutlineFolderAdd;
      case 'folder-download':
        return OutlineFolderDownload;
      case 'folder-open':
        return OutlineFolderOpen;
      case 'folder-remove':
        return OutlineFolderRemove;
      case 'folder':
        return OutlineFolder;
      case 'gift':
        return OutlineGift;
      case 'globe-alt':
        return OutlineGlobeAlt;
      case 'globe':
        return OutlineGlobe;
      case 'hand':
        return OutlineHand;
      case 'hashtag':
        return OutlineHashtag;
      case 'heart':
        return OutlineHeart;
      case 'home':
        return OutlineHome;
      case 'identification':
        return OutlineIdentification;
      case 'inbox-in':
        return OutlineInboxIn;
      case 'inbox':
        return OutlineInbox;
      case 'information-circle':
        return OutlineInformationCircle;
      case 'key':
        return OutlineKey;
      case 'library':
        return OutlineLibrary;
      case 'light-bulb':
        return OutlineLightBulb;
      case 'lightning-bolt':
        return OutlineLightningBolt;
      case 'link':
        return OutlineLink;
      case 'location-marker':
        return OutlineLocationMarker;
      case 'lock-closed':
        return OutlineLockClosed;
      case 'lock-open':
        return OutlineLockOpen;
      case 'login':
        return OutlineLogin;
      case 'logout':
        return OutlineLogout;
      case 'mail-open':
        return OutlineMailOpen;
      case 'mail':
        return OutlineMail;
      case 'map':
        return OutlineMap;
      case 'menu-alt-1':
        return OutlineMenuAlt1;
      case 'menu-alt-2':
        return OutlineMenuAlt2;
      case 'menu-alt-3':
        return OutlineMenuAlt3;
      case 'menu-alt-4':
        return OutlineMenuAlt4;
      case 'menu':
        return OutlineMenu;
      case 'microphone':
        return OutlineMicrophone;
      case 'minus-circle':
        return OutlineMinusCircle;
      case 'minus-sm':
        return OutlineMinusSm;
      case 'minus':
        return OutlineMinus;
      case 'moon':
        return OutlineMoon;
      case 'music-note':
        return OutlineMusicNote;
      case 'newspaper':
        return OutlineNewspaper;
      case 'no-symbol':
        return OutlineNoSymbol;
      case 'office-building':
        return OutlineOfficeBuilding;
      case 'paper-airplane':
        return OutlinePaperAirplane;
      case 'paper-clip':
        return OutlinePaperClip;
      case 'pause':
        return OutlinePause;
      case 'pencil-alt':
        return OutlinePencilAlt;
      case 'pencil':
        return OutlinePencil;
      case 'phone-incoming':
        return OutlinePhoneIncoming;
      case 'phone-missed-call':
        return OutlinePhoneMissedCall;
      case 'phone-outgoing':
        return OutlinePhoneOutgoing;
      case 'phone':
        return OutlinePhone;
      case 'photograph':
        return OutlinePhotograph;
      case 'play':
        return OutlinePlay;
      case 'plus-circle':
        return OutlinePlusCircle;
      case 'plus-sm':
        return OutlinePlusSm;
      case 'plus':
        return OutlinePlus;
      case 'presentation-chart-bar':
        return OutlinePresentationChartBar;
      case 'presentation-chart-line':
        return OutlinePresentationChartLine;
      case 'printer':
        return OutlinePrinter;
      case 'puzzle':
        return OutlinePuzzle;
      case 'qrcode':
        return OutlineQrcode;
      case 'question-mark-circle':
        return OutlineQuestionMarkCircle;
      case 'receipt-refund':
        return OutlineReceiptRefund;
      case 'receipt-tax':
        return OutlineReceiptTax;
      case 'refresh':
        return OutlineRefresh;
      case 'reply':
        return OutlineReply;
      case 'rewind':
        return OutlineRewind;
      case 'rss':
        return OutlineRss;
      case 'save-as':
        return OutlineSaveAs;
      case 'save':
        return OutlineSave;
      case 'scale':
        return OutlineScale;
      case 'scissors':
        return OutlineScissors;
      case 'search-circle':
        return OutlineSearchCircle;
      case 'search':
        return OutlineSearch;
      case 'selector':
        return OutlineSelector;
      case 'server':
        return OutlineServer;
      case 'share':
        return OutlineShare;
      case 'shield-check':
        return OutlineShieldCheck;
      case 'shield-exclamation':
        return OutlineShieldExclamation;
      case 'shopping-bag':
        return OutlineShoppingBag;
      case 'shopping-cart':
        return OutlineShoppingCart;
      case 'sort-ascending':
        return OutlineSortAscending;
      case 'sort-descending':
        return OutlineSortDescending;
      case 'sparkles':
        return OutlineSparkles;
      case 'speakerphone':
        return OutlineSpeakerphone;
      case 'star':
        return OutlineStar;
      case 'status-offline':
        return OutlineStatusOffline;
      case 'status-online':
        return OutlineStatusOnline;
      case 'stop':
        return OutlineStop;
      case 'sun':
        return OutlineSun;
      case 'support':
        return OutlineSupport;
      case 'switch-horizontal':
        return OutlineSwitchHorizontal;
      case 'switch-vertical':
        return OutlineSwitchVertical;
      case 'table':
        return OutlineTable;
      case 'tag':
        return OutlineTag;
      case 'template':
        return OutlineTemplate;
      case 'terminal':
        return OutlineTerminal;
      case 'thumb-down':
        return OutlineThumbDown;
      case 'thumb-up':
        return OutlineThumbUp;
      case 'ticket':
        return OutlineTicket;
      case 'translate':
        return OutlineTranslate;
      case 'trash':
        return OutlineTrash;
      case 'trending-down':
        return OutlineTrendingDown;
      case 'trending-up':
        return OutlineTrendingUp;
      case 'truck':
        return OutlineTruck;
      case 'upload':
        return OutlineUpload;
      case 'user-add':
        return OutlineUserAdd;
      case 'user-circle':
        return OutlineUserCircle;
      case 'user-group':
        return OutlineUserGroup;
      case 'user-remove':
        return OutlineUserRemove;
      case 'user':
        return OutlineUser;
      case 'users':
        return OutlineUsers;
      case 'variable':
        return OutlineVariable;
      case 'video-camera':
        return OutlineVideoCamera;
      case 'view-boards':
        return OutlineViewBoards;
      case 'view-grid-add':
        return OutlineViewGridAdd;
      case 'view-grid':
        return OutlineViewGrid;
      case 'view-list':
        return OutlineViewList;
      case 'volume-off':
        return OutlineVolumeOff;
      case 'volume-up':
        return OutlineVolumeUp;
      case 'wifi':
        return OutlineWifi;
      case 'x-circle':
        return OutlineXCircle;
      case 'x':
        return OutlineX;
      case 'zoom-in':
        return OutlineZoomIn;
      case 'zoom-out':
        return OutlineZoomOut;
      default:
        return OutlineDocument;
    }
  }
};

type Props = {
  name: UIIconName;
  size?: 'tiny' | 'small' | 'large' | 'huge';
  color?: 'gray' | 'red' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple' | 'pink' | 'white';
  colorIntensity?: number;
  fitted?: boolean;
  solid?: boolean;
  className?: string;
};

function Icon({ name, size, color, colorIntensity = 700, fitted, solid, className }: Props) {
  const classArray = ['inline-block'];
  switch (size) {
    case 'tiny':
      classArray.push('h-4 w-4');
      break;
    case 'small':
      classArray.push('h-5 w-5');
      break;
    case 'large':
      classArray.push('h-6 w-6');
      break;
    case 'huge':
      classArray.push('h-7 w-7');
      break;
    default:
      classArray.push('h-5 w-5');
      break;
  }
  switch (color) {
    case 'gray':
      classArray.push(`text-gray-${colorIntensity}`);
      break;
    case 'red':
      classArray.push(`text-red-${colorIntensity}`);
      break;
    case 'yellow':
      classArray.push(`text-yellow-${colorIntensity}`);
      break;
    case 'green':
      classArray.push(`text-green-${colorIntensity}`);
      break;
    case 'blue':
      classArray.push(`text-blue-${colorIntensity}`);
      break;
    case 'indigo':
      classArray.push(`text-indigo-${colorIntensity}`);
      break;
    case 'purple':
      classArray.push(`text-purple-${colorIntensity}`);
      break;
    case 'pink':
      classArray.push(`text-pink-${colorIntensity}`);
      break;
    case 'white':
      classArray.push('text-white');
      break;
    default:
      break;
  }
  if (!fitted) {
    classArray.push('mr-0.5');
  }
  const TagName = getIcon(name, solid);
  return <TagName className={className || classArray.join(' ')} />;
}

export default Icon;
export {
  OutlineAcademicCap,
  OutlineAdjustments,
  OutlineAnnotation,
  OutlineArchive,
  OutlineArrowCircleDown,
  OutlineArrowCircleLeft,
  OutlineArrowCircleRight,
  OutlineArrowCircleUp,
  OutlineArrowDown,
  OutlineArrowLeft,
  OutlineArrowNarrowDown,
  OutlineArrowNarrowLeft,
  OutlineArrowNarrowRight,
  OutlineArrowNarrowUp,
  OutlineArrowRight,
  OutlineArrowUp,
  OutlineArrowsExpand,
  OutlineAtSymbol,
  OutlineBackspace,
  OutlineBadgeCheck,
  OutlineBan,
  OutlineBeaker,
  OutlineBell,
  OutlineBookOpen,
  OutlineBookmarkAlt,
  OutlineBookmark,
  OutlineBriefcase,
  OutlineCake,
  OutlineCalculator,
  OutlineCalendar,
  OutlineCamera,
  OutlineCash,
  OutlineChartBar,
  OutlineChartPie,
  OutlineChartSquareBar,
  OutlineChatAlt2,
  OutlineChatAlt,
  OutlineChat,
  OutlineCheckCircle,
  OutlineCheck,
  OutlineChevronDoubleDown,
  OutlineChevronDoubleLeft,
  OutlineChevronDoubleRight,
  OutlineChevronDoubleUp,
  OutlineChevronDown,
  OutlineChevronLeft,
  OutlineChevronRight,
  OutlineChevronUp,
  OutlineChip,
  OutlineClipboardCheck,
  OutlineClipboardCopy,
  OutlineClipboardList,
  OutlineClipboard,
  OutlineClock,
  OutlineCloudDownload,
  OutlineCloudUpload,
  OutlineCloud,
  OutlineCode,
  OutlineCog,
  OutlineCollection,
  OutlineColorSwatch,
  OutlineCreditCard,
  OutlineCubeTransparent,
  OutlineCube,
  OutlineCurrencyBangladeshi,
  OutlineCurrencyDollar,
  OutlineCurrencyEuro,
  OutlineCurrencyPound,
  OutlineCurrencyRupee,
  OutlineCurrencyYen,
  OutlineCursorClick,
  OutlineDatabase,
  OutlineDesktopComputer,
  OutlineDeviceMobile,
  OutlineDeviceTablet,
  OutlineDocumentAdd,
  OutlineDocumentDownload,
  OutlineDocumentDuplicate,
  OutlineDocumentRemove,
  OutlineDocumentReport,
  OutlineDocumentSearch,
  OutlineDocumentText,
  OutlineDocument,
  OutlineDotsCircleHorizontal,
  OutlineDotsHorizontal,
  OutlineDotsVertical,
  OutlineDownload,
  OutlineDuplicate,
  OutlineEmojiHappy,
  OutlineEmojiSad,
  OutlineExclamationCircle,
  OutlineExclamation,
  OutlineExternalLink,
  OutlineEyeOff,
  OutlineEye,
  OutlineFastForward,
  OutlineFilm,
  OutlineFilter,
  OutlineFingerPrint,
  OutlineFire,
  OutlineFlag,
  OutlineFolderAdd,
  OutlineFolderDownload,
  OutlineFolderOpen,
  OutlineFolderRemove,
  OutlineFolder,
  OutlineGift,
  OutlineGlobeAlt,
  OutlineGlobe,
  OutlineHand,
  OutlineHashtag,
  OutlineHeart,
  OutlineHome,
  OutlineIdentification,
  OutlineInboxIn,
  OutlineInbox,
  OutlineInformationCircle,
  OutlineKey,
  OutlineLibrary,
  OutlineLightBulb,
  OutlineLightningBolt,
  OutlineLink,
  OutlineLocationMarker,
  OutlineLockClosed,
  OutlineLockOpen,
  OutlineLogin,
  OutlineLogout,
  OutlineMailOpen,
  OutlineMail,
  OutlineMap,
  OutlineMenuAlt1,
  OutlineMenuAlt2,
  OutlineMenuAlt3,
  OutlineMenuAlt4,
  OutlineMenu,
  OutlineMicrophone,
  OutlineMinusCircle,
  OutlineMinusSm,
  OutlineMinus,
  OutlineMoon,
  OutlineMusicNote,
  OutlineNewspaper,
  OutlineOfficeBuilding,
  OutlinePaperAirplane,
  OutlinePaperClip,
  OutlinePause,
  OutlinePencilAlt,
  OutlinePencil,
  OutlinePhoneIncoming,
  OutlinePhoneMissedCall,
  OutlinePhoneOutgoing,
  OutlinePhone,
  OutlinePhotograph,
  OutlinePlay,
  OutlinePlusCircle,
  OutlinePlusSm,
  OutlinePlus,
  OutlinePresentationChartBar,
  OutlinePresentationChartLine,
  OutlinePrinter,
  OutlinePuzzle,
  OutlineQrcode,
  OutlineQuestionMarkCircle,
  OutlineReceiptRefund,
  OutlineReceiptTax,
  OutlineRefresh,
  OutlineReply,
  OutlineRewind,
  OutlineRss,
  OutlineSaveAs,
  OutlineSave,
  OutlineScale,
  OutlineScissors,
  OutlineSearchCircle,
  OutlineSearch,
  OutlineSelector,
  OutlineServer,
  OutlineShare,
  OutlineShieldCheck,
  OutlineShieldExclamation,
  OutlineShoppingBag,
  OutlineShoppingCart,
  OutlineSortAscending,
  OutlineSortDescending,
  OutlineSparkles,
  OutlineSpeakerphone,
  OutlineStar,
  OutlineStatusOffline,
  OutlineStatusOnline,
  OutlineStop,
  OutlineSun,
  OutlineSupport,
  OutlineSwitchHorizontal,
  OutlineSwitchVertical,
  OutlineTable,
  OutlineTag,
  OutlineTemplate,
  OutlineTerminal,
  OutlineThumbDown,
  OutlineThumbUp,
  OutlineTicket,
  OutlineTranslate,
  OutlineTrash,
  OutlineTrendingDown,
  OutlineTrendingUp,
  OutlineTruck,
  OutlineUpload,
  OutlineUserAdd,
  OutlineUserCircle,
  OutlineUserGroup,
  OutlineUserRemove,
  OutlineUser,
  OutlineUsers,
  OutlineVariable,
  OutlineVideoCamera,
  OutlineViewBoards,
  OutlineViewGridAdd,
  OutlineViewGrid,
  OutlineViewList,
  OutlineVolumeOff,
  OutlineVolumeUp,
  OutlineWifi,
  OutlineXCircle,
  OutlineX,
  OutlineZoomIn,
  OutlineZoomOut,
  SolidAcademicCap,
  SolidAdjustments,
  SolidAnnotation,
  SolidArchive,
  SolidArrowCircleDown,
  SolidArrowCircleLeft,
  SolidArrowCircleRight,
  SolidArrowCircleUp,
  SolidArrowDown,
  SolidArrowLeft,
  SolidArrowNarrowDown,
  SolidArrowNarrowLeft,
  SolidArrowNarrowRight,
  SolidArrowNarrowUp,
  SolidArrowRight,
  SolidArrowUp,
  SolidArrowsExpand,
  SolidAtSymbol,
  SolidBackspace,
  SolidBadgeCheck,
  SolidBan,
  SolidBeaker,
  SolidBell,
  SolidBookOpen,
  SolidBookmarkAlt,
  SolidBookmark,
  SolidBriefcase,
  SolidCake,
  SolidCalculator,
  SolidCalendar,
  SolidCamera,
  SolidCash,
  SolidChartBar,
  SolidChartPie,
  SolidChartSquareBar,
  SolidChatAlt2,
  SolidChatAlt,
  SolidChat,
  SolidCheckCircle,
  SolidCheck,
  SolidChevronDoubleDown,
  SolidChevronDoubleLeft,
  SolidChevronDoubleRight,
  SolidChevronDoubleUp,
  SolidChevronDown,
  SolidChevronLeft,
  SolidChevronRight,
  SolidChevronUp,
  SolidChip,
  SolidClipboardCheck,
  SolidClipboardCopy,
  SolidClipboardList,
  SolidClipboard,
  SolidClock,
  SolidCloudDownload,
  SolidCloudUpload,
  SolidCloud,
  SolidCode,
  SolidCog,
  SolidCollection,
  SolidColorSwatch,
  SolidCreditCard,
  SolidCubeTransparent,
  SolidCube,
  SolidCurrencyBangladeshi,
  SolidCurrencyDollar,
  SolidCurrencyEuro,
  SolidCurrencyPound,
  SolidCurrencyRupee,
  SolidCurrencyYen,
  SolidCursorClick,
  SolidDatabase,
  SolidDesktopComputer,
  SolidDeviceMobile,
  SolidDeviceTablet,
  SolidDocumentAdd,
  SolidDocumentDownload,
  SolidDocumentDuplicate,
  SolidDocumentRemove,
  SolidDocumentReport,
  SolidDocumentSearch,
  SolidDocumentText,
  SolidDocument,
  SolidDotsCircleHorizontal,
  SolidDotsHorizontal,
  SolidDotsVertical,
  SolidDownload,
  SolidDuplicate,
  SolidEmojiHappy,
  SolidEmojiSad,
  SolidExclamationCircle,
  SolidExclamation,
  SolidExternalLink,
  SolidEyeOff,
  SolidEye,
  SolidFastForward,
  SolidFilm,
  SolidFilter,
  SolidFingerPrint,
  SolidFire,
  SolidFlag,
  SolidFolderAdd,
  SolidFolderDownload,
  SolidFolderOpen,
  SolidFolderRemove,
  SolidFolder,
  SolidGift,
  SolidGlobeAlt,
  SolidGlobe,
  SolidHand,
  SolidHashtag,
  SolidHeart,
  SolidHome,
  SolidIdentification,
  SolidInboxIn,
  SolidInbox,
  SolidInformationCircle,
  SolidKey,
  SolidLibrary,
  SolidLightBulb,
  SolidLightningBolt,
  SolidLink,
  SolidLocationMarker,
  SolidLockClosed,
  SolidLockOpen,
  SolidLogin,
  SolidLogout,
  SolidMailOpen,
  SolidMail,
  SolidMap,
  SolidMenuAlt1,
  SolidMenuAlt2,
  SolidMenuAlt3,
  SolidMenuAlt4,
  SolidMenu,
  SolidMicrophone,
  SolidMinusCircle,
  SolidMinusSm,
  SolidMinus,
  SolidMoon,
  SolidMusicNote,
  SolidNewspaper,
  SolidOfficeBuilding,
  SolidPaperAirplane,
  SolidPaperClip,
  SolidPause,
  SolidPencilAlt,
  SolidPencil,
  SolidPhoneIncoming,
  SolidPhoneMissedCall,
  SolidPhoneOutgoing,
  SolidPhone,
  SolidPhotograph,
  SolidPlay,
  SolidPlusCircle,
  SolidPlusSm,
  SolidPlus,
  SolidPresentationChartBar,
  SolidPresentationChartLine,
  SolidPrinter,
  SolidPuzzle,
  SolidQrcode,
  SolidQuestionMarkCircle,
  SolidReceiptRefund,
  SolidReceiptTax,
  SolidRefresh,
  SolidReply,
  SolidRewind,
  SolidRss,
  SolidSaveAs,
  SolidSave,
  SolidScale,
  SolidScissors,
  SolidSearchCircle,
  SolidSearch,
  SolidSelector,
  SolidServer,
  SolidShare,
  SolidShieldCheck,
  SolidShieldExclamation,
  SolidShoppingBag,
  SolidShoppingCart,
  SolidSortAscending,
  SolidSortDescending,
  SolidSparkles,
  SolidSpeakerphone,
  SolidStar,
  SolidStatusOffline,
  SolidStatusOnline,
  SolidStop,
  SolidSun,
  SolidSupport,
  SolidSwitchHorizontal,
  SolidSwitchVertical,
  SolidTable,
  SolidTag,
  SolidTemplate,
  SolidTerminal,
  SolidThumbDown,
  SolidThumbUp,
  SolidTicket,
  SolidTranslate,
  SolidTrash,
  SolidTrendingDown,
  SolidTrendingUp,
  SolidTruck,
  SolidUpload,
  SolidUserAdd,
  SolidUserCircle,
  SolidUserGroup,
  SolidUserRemove,
  SolidUser,
  SolidUsers,
  SolidVariable,
  SolidVideoCamera,
  SolidViewBoards,
  SolidViewGridAdd,
  SolidViewGrid,
  SolidViewList,
  SolidVolumeOff,
  SolidVolumeUp,
  SolidWifi,
  SolidXCircle,
  SolidX,
  SolidZoomIn,
  SolidZoomOut,
};
